export const getOverallStatus = (statuses) => {
    if (statuses.some((status) => status === "error")) {
        return "error";
    }
    if (statuses.some((status) => status === "loading" || status === "unset")) {
        return "loading";
    }
    return "loaded";
};
//# sourceMappingURL=status-utils.js.map